/*
 BackgroundImage component
 url match: / or /login
 Displays email id and password field
 with BackgroundImage button
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { loginStyles } from '../Styles/loginStyles';
import { ReactSVG } from 'react-svg'
import Images from '../Theme/Images';
import Loader from 'react-loader-spinner'
import Typography from '@material-ui/core/Typography';

@observer
class BackgroundImage extends React.Component {

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.bgImageContainer}>
                <img alt="Loading app" className={classes.bgImage} src={Images.bgImage}></img>
                <div className={classes.headingIcon}></div>
                <div className={classes.headingContainer}>
                    <Typography className={classes.mainHeading}>EXTRACT DOCUMENT DATA FASTER THAN EVER BEFORE</Typography>
                    <Typography className={classes.subHeading}>Using AI to capture business data like a human.</Typography>
                    <Typography className={classes.subHeading}> Set workflows that reduce manual data entry and avoid error-prone OCR rules and templates.</Typography>
                </div>
                <ReactSVG className={classes.wave} src={Images.wave}/>

            </div>
        );
    }
}
export default withStyles(loginStyles, { withTheme: true })(withRouter(BackgroundImage));
